import { render, staticRenderFns } from "./SystemCommands.vue?vue&type=template&id=47368b02&scoped=true&"
import script from "./SystemCommands.vue?vue&type=script&lang=ts&"
export * from "./SystemCommands.vue?vue&type=script&lang=ts&"
import style0 from "./SystemCommands.vue?vue&type=style&index=0&id=47368b02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47368b02",
  null
  
)

export default component.exports